// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"cda612ba","845":"ae719316"}[chunkId] + ".chunk.js";
};